import React from 'react';
import replaceCharacters from '../../helpers';

const AmountGeneralRequest = ({ id, Header, accessor }) => {
    return {
        Header: () => Header,
        id: id,
        Cell: ({ row }) => {
            return (
                <span>
                    {replaceCharacters('cast_amount', row.original[accessor])}
                </span>
            );
        },
    };
};

export default AmountGeneralRequest;
